<template>
    <CieloLayout>
        <div class="payment-success">
            <TitleText level="2">
                {{ $ml.get('pixSuccessBody') }}
            </TitleText>
            <CopyQrCodeString :qr-code-string="qrCodeString" />
            <div class="payment-success__detail">
                <span v-text="$ml.get('pixDescription')" tabindex="0" />
            </div>
            <div class="payment-success__card-img">
                <img :src="qrCodeImage" class="payment-success__qr-code-image" :alt="$ml.get('altPix')" tabindex="0" />
            </div>
        </div>
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);
import CopyQrCodeString from '@/components/CopyQrCodeString';
import TitleText from '@/components/template/TitleText';
import store from '@/store';

export default {
  components: {
    CieloLayout,
    CopyQrCodeString,
    TitleText
  },

  computed: {
    qrCodeImage: function () {
      return `data:image/png;base64, ${store.state.pixPayment.Response.QrCodeBase64Image}`;
    },

    qrCodeString: function () {
      return store.state.pixPayment.Response.QrCodeString;
    },
  },

  beforeRouteEnter(to, from, next) {
    if (!store.state.preorder.TransactionIsFinalized)
      return next(false);

    next();
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderStatus')
      next();
    else
      next(false);
  }
};

</script>

<style lang="scss" scoped>
.payment-success {

  display: flex;
  flex-direction: column;
  gap: 20px;

  @media screen and (max-width: 1024px) {
    align-items: center;
  }

  &__card-img {
    display: flex;
    padding: 40px 0px;
    justify-content: center;
    gap: 8px;
    border-radius: 8px;
    background: #EFF1F3;

    @media screen and (max-width: 1024px) {
      background: none;
      padding: 0px;
    }
  }

  &__detail {
    font-size: 16px;
    color: #425865;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-top: 12px;

  }

  &__qr-code-image {
    width: 264px;
    height: 266px;
  }

}
</style>
